function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import Button from "segments/desktop/core-components/button/button";
import { StyledTitleOnlyParagraph } from "./title-only-paragraph.scss";
import DefaultProps from "./default-props";
import classnames from "classnames";
import Colors from "styles/colors";
import Title from "segments/desktop/core-components/title/title";
class TitleOnlyParagraph extends PureComponent {
    getComponentInlineStyles() {
        const { textAlign, textColor, fontSize, titleSize } = this.props;
        const inlineStyles = {
            textAlign,
            color: Colors[textColor]
        };
        if (!titleSize) inlineStyles.fontSize = fontSize;
        return inlineStyles;
    }
    render() {
        const { title, buttonConfig, textAlign, titleSize, isFirstSegment, titleColor } = this.props;
        const inlineComponentStyles = this.getComponentInlineStyles();
        return /*#__PURE__*/ _jsxs(StyledTitleOnlyParagraph, {
            className: "title-only-paragraph",
            style: inlineComponentStyles,
            children: [
                /*#__PURE__*/ _jsx(Title, {
                    title: title,
                    titleSize: titleSize,
                    isFirstSegment: isFirstSegment,
                    titleColor: titleColor
                }),
                buttonConfig && /*#__PURE__*/ _jsx("div", {
                    className: classnames("button-wrapper", textAlign),
                    children: /*#__PURE__*/ _jsx(Button, _object_spread({}, buttonConfig))
                })
            ]
        });
    }
}
export { TitleOnlyParagraph as default };
TitleOnlyParagraph.defaultProps = DefaultProps;
